<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';

const props = withDefaults(
    defineProps<{
        src: string;
        loop?: boolean;
        label?: string;
    }>(),
    { loop: true, label: '' },
);

type DotLottieInstance = {
    isLoaded?: boolean;
    play(): boolean;
    setLoop(loop: boolean): void;
};
type DotLottieElement = HTMLElement & {
    dotLottie?: DotLottieInstance | null;
};

const player = ref<DotLottieElement | null>(null);
let startTimer: number | null = null;
let attempts = 0;

onMounted(startPlayer);

onBeforeUnmount(() => {
    if (startTimer !== null) {
        window.clearTimeout(startTimer);
    }
});

function startPlayer(): void {
    const instance = player.value?.dotLottie;

    if (instance?.isLoaded) {
        instance.setLoop(props.loop);
        instance.play();

        return;
    }

    attempts += 1;

    if (attempts < 50) {
        startTimer = window.setTimeout(startPlayer, 100);
    }
}
</script>

<template>
    <dotlottie-wc
        v-if="loop"
        ref="player"
        class="lottie-animation"
        :src="src"
        autoplay
        loop
        :aria-label="label || undefined"
        :aria-hidden="label ? undefined : 'true'"
    />
    <dotlottie-wc
        v-else
        ref="player"
        class="lottie-animation"
        :src="src"
        autoplay
        :aria-label="label || undefined"
        :aria-hidden="label ? undefined : 'true'"
    />
</template>

<style scoped>
.lottie-animation {
    display: block;
    width: 100%;
    height: 100%;
}
</style>
